<section class="">
    <div class="container py-0">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 bg-transparent">
                <li class="breadcrumb-item" routerLinkActive="active"><a class="text-dark text-decoration-none"
                        [routerLink]="['/']">Home</a>
                </li>
                <li class="breadcrumb-item" routerLinkActive="active"><a class="text-dark text-decoration-none"
                        [routerLink]="['/faq']">FAQs</a></li>
            </ol>
        </nav>
    </div>
</section>